export default {"src":"/_next/static/media/22.cfaebe6a.svg","height":25,"width":25};